import { useEffect, useRef } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { useClaimForm } from '../context/ClaimFormContext'
import { clearClaimLinkCookies } from '../utils/claimLinkCookies'

function getCookie(name) {
  const value = document.cookie.split('; ').find((cookie) => cookie.startsWith(`${name}=`))
  return value ? decodeURIComponent(value.slice(name.length + 1)) : null
}

export function useClaimLink() {
  const location = useLocation()
  const navigate = useNavigate()
  const { reset, setData } = useClaimForm()
  const handledLinkRef = useRef(null)

  useEffect(() => {
    if (location.pathname.startsWith('/upload')) return

    const params = new URLSearchParams(location.search)
    const id = params.get('id') || getCookie('claimLinkId')
    const promo = params.get('promo') || getCookie('promo')
    const linkKey = id && promo ? `${id}:${promo}` : null

    if (!linkKey || handledLinkRef.current === linkKey) return
    handledLinkRef.current = linkKey
    sessionStorage.removeItem('claimform_upload_case_uuid')

    // Navigate to step4 immediately with a loading state
    reset()
    setData((previous) => ({
      ...previous,
      lastReachedStep: '/step4',
      promo,
      // reset() cleared the promocode of the link, the validation step must start with it
      validation: { ...previous.validation, hasPromocode: true, promocode: promo },
      claimLinkLoading: true,
      claimLinkNotFound: false,
    }))
    navigate('/step4', { replace: true })

    // Fetch flight data in the background
    fetch(`/api/claimapi/claimlink?id=${encodeURIComponent(id)}&promo=${encodeURIComponent(promo)}`)
      .then((response) => (response.ok ? response.json() : Promise.reject()))
      .then(({ flights }) => {
        const firstFlight = flights?.[0] || null
        setData((previous) => ({
          ...previous,
          routeDeparture: firstFlight?.departure || '',
          routeDestination: firstFlight?.destination || '',
          routeDepartureData: firstFlight?.departureData || null,
          routeDestinationData: firstFlight?.destinationData || null,
          flights: Array.isArray(flights) ? flights : [],
          claimLinkNotFound: !Array.isArray(flights) || flights.length === 0,
          claimLinkLoading: false,
        }))
      })
      .catch(() => {
        setData((previous) => ({
          ...previous,
          flights: [],
          claimLinkNotFound: true,
          claimLinkLoading: false,
        }))
      })
      .finally(clearClaimLinkCookies)
  }, [location.pathname, location.search, navigate, reset, setData])
}
